export default __webpack_public_path__ + "static/media/four.dbea597a.jpeg";